import { TrackerActivationType } from '@racemap/utilities/consts/trackers';
import type { TableCellProps } from 'react-virtualized';
import {
  type ManagedTracker,
  TrackerColumnKeys,
} from '../../../../store/trackers/trackers_reducers';
import {
  ActiveUntilTag,
  ArchivedTrackerTypeTag,
  UnusedTrackerTypeTag,
} from '../../../BasicComponents/ActivationTypeTags';
import { Columns } from '../../../DataTable';

interface CellProps extends TableCellProps {
  cellData?: ManagedTracker['activation'];
  rowData: ManagedTracker;
}

export const ActivationColumn = () => {
  const cellRenderer = ({ rowData }: CellProps) => {
    if (rowData == null) return <></>;
    switch (rowData.activation.type) {
      case TrackerActivationType.RACEMAPTRACKER:
        return <ActiveUntilTag />;
      case TrackerActivationType.ARCHIVED:
        return <ArchivedTrackerTypeTag />;
      default:
        if (
          rowData.activation.paidUntil != null &&
          new Date(rowData.activation.paidUntil) > new Date()
        ) {
          return <ActiveUntilTag paidUntil={rowData.activation.paidUntil} />;
        }
        return <UnusedTrackerTypeTag />;
    }
  };

  return Columns.sortingColumn({
    dataKey: TrackerColumnKeys.STATE,
    label: 'State',
    cellRenderer,
    width: 80,
    style: { justifyContent: 'center' },
    headerStyle: { justifyContent: 'center' },
    sortingMethod: (
      cellDataA: ManagedTracker['activation'],
      cellDataB: ManagedTracker['activation'],
    ) => {
      return (
        new Date(cellDataB?.paidUntil || Number.POSITIVE_INFINITY).getTime() -
        new Date(cellDataA?.paidUntil || Number.NEGATIVE_INFINITY).getTime()
      );
    },
  });
};
